module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "main-menu__submenu"
  }, [_c('li', {
    staticClass: "main-menu__item has-droprdown"
  }, [_c('router-link', {
    class: _vm.activeMenu,
    attrs: {
      "to": {
        name: 'Operations'
      }
    }
  }, [_c('md-icon', [_vm._v("monetization_on")]), _vm._v(" "), _c('span', [_vm._v("Финансы")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a3238b7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/finance/menus/MainMenu.vue
// module id = 1153
// module chunks = 0